import React from "react";
import { ShieldCheck, ShieldWarning, Plugs, PlugsConnected } from "@phosphor-icons/react";

const TONE = {
  active: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", icon: <PlugsConnected size={12} weight="fill" /> },
  unconfigured: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", icon: <ShieldWarning size={12} weight="fill" /> },
  unreachable: { bg: "bg-rose-50", text: "text-rose-800", border: "border-rose-200", icon: <Plugs size={12} weight="fill" /> },
  loading: { bg: "bg-stone-100", text: "text-stone-600", border: "border-stone-200", icon: <ShieldCheck size={12} /> },
};

export const KatlasStatusBadge = ({ status }) => {
  const key = (status?.status || "loading").toLowerCase();
  const tone = TONE[key] || TONE.loading;
  const label = status?.label || "Checking KATLAS node…";
  return (
    <div
      data-testid="katlas-status-badge"
      className={`flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-medium px-2 py-1 rounded-sm border ${tone.bg} ${tone.text} ${tone.border}`}
    >
      {tone.icon}
      <span>{label}</span>
    </div>
  );
};
